<template>
  <p>GoSandwell {{ appVersion }}</p>
</template>

<script>
  export default {
    name: 'Version',

    data () {
      return {
        appVersion: APPLICATION_VERSION
      }
    }
  }
</script>



// WEBPACK FOOTER //
// resources/js/shared/components/Version.vue